import { useContext } from 'react';
import { RemoteDataContext } from '../../remote-data/RemoteDataContext';

const useRemoteDataEmptyHandler = () => {
  const context = useContext(RemoteDataContext);

  if (!context) {
    throw Error('useRemoteDataEmptyHandler need to be used under the <RemoteDataProvider />');
  }

  const {
    global: { emptyData },
  } = context;

  return [undefined, emptyData];
};

export default useRemoteDataEmptyHandler;
